<template>
  <div class="icon">
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         width="283.5"
         height="143.9" viewBox="0 0 283.5 143.9" xml:space="preserve">
  <path d="M144.8,115.8h-17.3L112.3,70h15.6l8.4,30.3h0.2l8.5-30.3h15.3L144.8,115.8z"/>
      <path d="M237.8,69.8h14.6v6.3h0.2c2.7-4.7,8.9-7.6,14.4-7.6c15.3,0,16.5,11.1,16.5,17.7v29.4h-15V93.5
			c0-6.3,0.7-12.6-7.5-12.6c-5.7,0-8.1,4.8-8.1,9.8v25h-15V69.8z"/>
      <path d="M161.1,83.8c0.3-6,3.1-9.9,7.2-12.3c4.1-2.3,9.4-3.2,14.6-3.2c10.9,0,21.4,2.4,21.4,15.4v20
			c0,3.9,0,8.1,1.8,11.7h-15.1c-0.5-1.4-0.7-2.8-0.9-4.3c-3.9,4.1-9.6,5.7-15.1,5.7c-8.7,0-15.6-4.4-15.6-13.9
			c0-14.9,16.2-13.8,26.7-15.9c2.6-0.5,4-1.4,4-4.2c0-3.4-4.1-4.8-7.2-4.8c-4.2,0-6.8,1.9-7.5,5.7H161.1z M180.6,107.5
			c7.2,0,9.5-4.1,9.2-13.5c-2.1,1.3-6,1.6-9.3,2.5c-3.4,0.8-6.2,2.2-6.2,5.8C174.3,106,177.2,107.5,180.6,107.5z"/>
      <path d="M228.2,63.7h-15V52.2h15V63.7z M213.2,69.5h15v45.8h-15V69.5z"/>
      <path d="M81.3,70.6l-0.4-1.3c0,0,0,0,0,0L81.3,70.6z"/>
      <path d="M74.3,69.3L68.9,86l5.7-16.6C74.4,69.4,74.3,69.3,74.3,69.3z"/>
      <path d="M88,37.6H67.3l-29.4,78.5h21l5-14.1h27.4l4.8,14.1h21.3L88,37.6z M67.5,90l1.4-4l5.4-16.7
		C71.2,68,69,65,69,61.4c0-4.8,3.9-8.6,8.6-8.6c4.8,0,8.6,3.9,8.6,8.6c0,3.6-2.2,6.7-5.3,7.9l0.4,1.3L87.6,90H67.5z"/>
      <path d="M147,59.2c-8.2-30.5-36.2-53.1-69.3-53.1C38.1,6.1,6.1,38.3,6.1,77.8c0,25.8,13.6,48.3,34.1,60.9l4.4-7.5
			c-18-11.1-30-30.8-30-53.5c0-34.8,28.4-63,63.2-63c29.1,0,53.4,19.6,60.6,46.5C138.5,61.2,147,59.2,147,59.2z"/>
      <path d="M2,77.7C2,35.9,35.9,2,77.7,2c35.1,0,64.6,23.8,73.2,56.2l1.8-0.5C143.7,24.6,113.6,0,77.7,0
			C34.8,0,0,35,0,77.9c0,28,15,52.3,37.2,66l1-1.7C16.5,129,2,105,2,77.7z"/>
</svg>
  </div>
</template>

<script>
export default {
  name: "AvainLogo.vue"
}
</script>
